import BatterySpecifications from './BatterySpecifications';

export default BatterySpecifications;
